import { render, staticRenderFns } from "./BaseAsideNavItemGroup.vue?vue&type=template&id=607f1c18&scoped=true&"
import script from "./BaseAsideNavItemGroup.vue?vue&type=script&lang=js&"
export * from "./BaseAsideNavItemGroup.vue?vue&type=script&lang=js&"
import style0 from "./BaseAsideNavItemGroup.vue?vue&type=style&index=0&id=607f1c18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "607f1c18",
  null
  
)

export default component.exports